<template>
	<v-card
		style = "
				width 		 : 100%; 
				height 		 : 100%; 
				object-fit 	 : fill;  
				border-color : grey;" 
		elevation 	= "10" 
		:class 		= "'pb-0'"
		outlined
	>
		<v-card-text 
			style = "
				width 		 : 100%; 
				height 		 : 100%; 
				object-fit 	 : fill;  
				border-color : grey;
				" 
			class = "pa-0 no-drag"
		>
			<l-map 
				ref 	= "myMap" 
				@ready  = "doSomethingOnReady()"
				:zoom   = "zoom" 
				:center = "center" 				
				style 	= "position     : backgound; z-index: 0;"
				:minZoom = "rectangle.min"

			>			
				<l-tile-layer 
					noWrap
					:minZoom 		= "rectangle.min"
					:url 		 	= "url"
					:attribution 	= "attribution"		
				></l-tile-layer>
				<v-marker-cluster 
					:ref 	 		= "'clusterRef' + layout_id"				
					:averageCenter  = "true"
					@ready 			= "actions('refresh_cluster')"
      				:ignoreHidden   = "true"
					:options 		= "clusterOptions"
				>
				<l-marker 
					v-for 	 = "marker_s, index_marker in marker_static" 
					:key  	 = "index_marker + 100" 	
					:ref     = "'lmarker' + index_marker + layout_id" 				
					:lat-lng = "marker_s.latln" 
					:visible = "marker_s.show"
					@click   = "render_popup(marker_s, index_marker)"
					:icon 	 = "marker_s.icon"
				>
					<l-tooltip 
						:options = "{ 
							permanent 	: false, 
							interactive : true 
						}"
					>
						  {{ marker_s.name }}
					</l-tooltip>
					<l-popup
						:ref 	= "'lpopup' + layout_id + index_marker"
						style 	= "padding: 0px; margin: 0px;"
						class   = "pa-0 ma-0"

						
					>
						<v-card
							outlined
							:color = "marker_s.color_pop"
							class  = "pa-0 ma-0"
						>
							<v-card-text
								style = "
									width  : 280px;
									height : 200px; 
									overflow-x 	: hidden; 
									overflow-y 	: hidden; "
								class = "pa-0"
							>				
								<cam
									v-if 				= "marker_s.deviceId && mode_active == 'devices'"
								 	:key 				= "layout_id + 'device_map' + marker_s.deviceId"
								 	:id_stream  		= "marker_s.deviceId"
								 	:show_bar 			= "false"
									:is_channel   		= "marker_s.channel ? marker_s.channel :  'hls'"
									:hostname			= "marker_s.name"
									:info_stream		= "{active:true, ...marker_s }"
									:info_to_component 	= "{ ...info_comp }" 
									video 				= "true"
									:layout_id 			= "layout_id + 'device_map_layout' + marker_s.deviceId"									
								></cam>
								<v-container fluid
									v-else-if  	= "mode_active == 'workstations'"
									style 		= "
												width  : 280px;
												height : 200px; 
												overflow-y 	: auto; "
								>
								<template
									v-for 		= "(item_dev, idx_dev) of marker_s.devices"
								>
										<cam
											:key 				= "layout_id + 'device_map_dev' +  idx_dev + marker_s.deviceId + item_dev.manager_id"
										 	:id_stream  		= "item_dev.deviceId"
										 	:show_bar 			= "false"
											:is_channel   		= "item_dev.channel ? item_dev.channel :  'hls'"
											:hostname			= "item_dev.name"
											:info_stream		= "{active:true}"
											:info_to_component 	= "{ ...item_dev }" 
											video 				= "true"
											:layout_id 			= "layout_id + 'device_map_layout_dev' + marker_s.deviceId + item_dev.manager_id"
										></cam>
										<!-- @update_of_component = "update_component_map($event, marker_s, index_marker)" -->
								</template>
								</v-container fluid>
								<v-img
									v-else
									:src = "$logos.no_img_found"
								>									
								</v-img>

							</v-card-text>
							<v-card-actions 
								v-show = "show.actions"
							>
								<v-btn
									color = "primary"
									x-small
								>
									{{ $ml.get('actions') }}
								</v-btn>
								<v-spacer></v-spacer>								
								<record 
									:key 				= "'record' + ID_notification"
									:ref_to_component	= "ID_notification"
									:info_to_component 	= "{ 
										info : { 
											deviceId : marker_s.deviceId
										}
									}"
								></record>
								<v-spacer></v-spacer>
								<v-btn
									color = "error"
									x-small
								>
									{{ $ml.get('ignore') }}
								</v-btn>
							</v-card-actions>
						</v-card>
					</l-popup>
				</l-marker>	
				</v-marker-cluster>
			</l-map>			
		</v-card-text>
	</v-card>
</template>
<script type="text/javascript">
	import { LMap, LTileLayer, LMarker, LIcon, LPopup, LTooltip, LRectangle } from 'vue2-leaflet';
	import 'leaflet/dist/leaflet.css';
	import 'leaflet.smooth_marker_bouncing'
	import L 						from 'leaflet';
	import { Icon } 				from 'leaflet';
	import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster'
	import cam 						from "@/components/cam_test.vue"
	import record  					from '@/components/sounds/record.vue'
	delete Icon.Default.prototype._getIconUrl;
	Icon.Default.imagePath = '.';
	export default{
		name : "mapInformation",
		props: [ "info_to_component", "layout_id"],
		components 	: {
		    LMap,
		    LTileLayer,
		    LMarker,
		    LIcon,
			LPopup,
			LTooltip,
			LRectangle,
			cam,
			'v-marker-cluster': Vue2LeafletMarkerCluster,
			record,
		}, // components
		data 	: (vm) => ({
			ref_to_component : "mapInformation",
			setting_img 	: {
				height  : 235,				
			}, 
			ID_notification : "mapInformation",
			map  			: null,
			url  			: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',// 'https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png',
			attribution 	: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
			// 'https://cartodb-basemaps-{s}.global.ssl.fastly.net/dark_all/{z}/{x}/{y}.png',//
		    zoom 			: 8,
		    center 			: [47.313220, -1.319482],
		    marker  		: false, 
		    markers 	  	: [],
			bounds 	 	 	: null,
		    locations    	: [],
			rectangle 		: {
			    bounds: [[85.17766, -179.99999], [-87.17766, 179.99999]],
			    limit_long : [-179.99999, 179.99999],
			    style: { color: 'blue', weight: 3 },
			    bounds_LT : null,
			    max 	: 50,
			    min  	: 2,
			},
			clusterOptions: {
				chunkedLoading 				: true,			    
	            singleMarkerMode: false,
			    disableClusteringAtZoom: 15,
	      	}, 
			info_comp 			: {
				list_no_show_bar : [ 
					"close",
					"redirect",
					"list_rois",
					"alert"
				]
			},
			mode_active 		: "devices", 
			show  			: {
				actions : false
			},
			streaming_active 	: {
		      	deviceId : "",
				close 	 : null 
			},
			is_map_ready 		: false,
			marker_static 		: [],
			maker_fit     		: [],
			info_map_devices	: {},
			rectangle 			: {
			    bounds: [[85.17766, -179.99999], [-87.17766, 179.99999]],
			    limit_long : [-179.99999, 179.99999],
			    style: { color: 'blue', weight: 3 },
			    bounds_LT : null,
			    max 	: 50,
			    min  	: 2,
			},
			events 				: {
				timer_out 		: null,
				timeout_out 	: 8, // seg
				timer_out_2 	: null,
				zoom_out 		: 14,
				array 			: [],
				current 		: null,
				lat 			: null,
				long  			: null, 
				is_shorting 	: false,
				time_short  	: 3.5, // seg
				array_devices 	: [],
			},
			list_icons : {
		   		police 	: null,
		   		cam 	: null,
		   		active 	: null,
		   		off 	: null,
		   		alert 	: null,
		   	},
		   	icon_selected 	: null,



		}), // data
		created(){
			this.renderIcons();			
			if (this.info_to_component) {
				this.renderLocations(this.info_to_component);
			}
		}, // created
		watch: {
			info_to_component: function(val){
				if (val) {
					this.renderLocations(val);
				}
			}
		}, // watch
		methods : {
			renderLocations(item){
				if (item) {					
					console.log("load map informations ", item)
					if (item && item.length > 0) {			
						let ev = this;									
						let temp_locts 	= [];
						let icon 		= this.renderSetIcon("off", "icon_return");
						item.forEach(function (location, index_a, array) {									    				
							if (location && location.latitude && location.longitude) {
								let long = ev.checkLong(location.longitude);
								// let info_dev = ev.info_map_devices && ev.info_map_devices[location.deviceId] ? ev.info_map_devices[location.deviceId] : { channel : "hls"};								
								ev.maker_fit.push(L.latLng(location.latitude, long))
								
								temp_locts.push(
									{
										latln 	 	: L.latLng(location.latitude, long),
										name 	 	: location && location.name ? location.name : 'Device',
										deviceId 	: location && location.deviceId ? location.deviceId : null,
										icon 	 	,
										marker   	: null,
										show 	 	: true,
										info_alert 	: { img : ev.$logos.no_img_found},
										// deviceId   	: location.deviceId, 
										state 		: 0, // 1 active, 0 off , 2 alert
										img_icon    : ev.img_icon_static,
										...location, 
										// ...info_dev 

								});							
							}
							if (array.length - 1 == index_a) {
								ev.marker_static = temp_locts;
								ev.renderBounds();
							}
						})			
					}					
				}
			}, // renderInfo

			renderBounds(){
	  			let ev = this;
	  			if (ev.maker_fit && ev.maker_fit.length > 0) {
	  				const timer = setTimeout(()=>{
						let bounds = new L.LatLngBounds(ev.maker_fit);
						if (ev.map && bounds){
							ev.map.fitBounds(bounds);										
							// ev.events.zoom_out = this.map._zoom;								
						}else{
							console.warn("Not editable , Not found some property : ", bounds)
						}
						clearTimeout(timer);
	  				}, 550)
				}
	  		}, // render bounds
			checkLong(item){
	  			if (item){
	  				if (item < this.rectangle.limit_long[0] && [-1, -0].includes(Math.sign(item))) {	  					
	  					item = (parseFloat(item) + parseInt(this.rectangle.limit_long[1])) + parseInt(this.rectangle.limit_long[1]);	
	  				}	  				
	  				if (item > this.rectangle.limit_long[1] && [1, 0].includes(Math.sign(item))) {	  					
	  					item = (parseFloat(item) - parseInt(this.rectangle.limit_long[1])) -  parseInt(this.rectangle.limit_long[1]);
	  				}
	  				if ((item < this.rectangle.limit_long[0] && [-1, -0].includes(Math.sign(item))) || (item > this.rectangle.limit_long[1] && [1, 0].includes(Math.sign(item)))) {
	  					item = this.checkLong(item);
	  				}
	  			}
	  			return item;
	  		}, // check long
			renderSetIcon(icon, type = 'icon', opt){
	  			if (type == 'img') {
	  				let path = '/img/';
	  				let ext  = '.jpg';
	  				if (!["police", "cam"].includes(icon)) {
	  					path = '/img/tags/cam/';
	  					ext  = '.png';
	  				}
					if (opt == 'static') {
		  				this.img_icon_static = this.$EXT + path + icon + ext;
		  			}
	  			}else	
  				if (type == 'icon' && this.list_icons && this.list_icons[icon]) {  					
  					this.icon_selected = this.list_icons[icon];
  				}else if (type == 'img_return') {
  					let path = '/img/';
	  				let ext  = '.jpg';
	  				if (!["police", "cam"].includes(icon)) {
	  					path = '/img/tags/cam/';
	  					ext  = '.png';
	  				}
	  				return  this.$EXT + path + icon + ext;
  				}else if (type == 'img_return') {
  					let path = '/img/';
	  				let ext  = '.jpg';
	  				if (!["police", "cam"].includes(icon)) {
	  					path = '/img/tags/cam/';
	  					ext  = '.png';
	  				}
	  				return  this.$EXT + path + icon + ext;
  				}else if (type == 'icon_return' && this.list_icons && this.list_icons[icon]) {

  					return this.list_icons[icon];
  				}
	  		}, // render set icon

	  		renderIcons(){
	  			if (this.list_icons) {
	  				for( let icon in this.list_icons){
	  					if (["police", "cam"].includes(icon)) {
		  					this.list_icons[icon] =  L.icon({
								iconUrl  : this.$EXT + `/img/${icon}.jpg`, // 'https://www.flaticon.es/premium-icon/icons/svg/1183/1183400.svg',
								iconSize : [32, 37],
								iconAnchor : [16, 37]
							});

	  					}else{
	  						this.list_icons[icon] =  L.icon({
								iconUrl  : this.$EXT + `/img/tags/cam/${icon}.png`, // 'https://www.flaticon.es/premium-icon/icons/svg/1183/1183400.svg',
								iconSize : [32, 37],
								iconAnchor : [16, 37]
							});

	  					}
	  				}
	  			}
	  		}, // render icons
			renderPopup(dev, idx){
				let vm = this; 
				this.streaming_active.deviceId = dev.deviceId;
				let ref_temp = 'lmarker' + idx + this.layout_id;
				vm.$refs[ref_temp][0].mapObject.getPopup().on('remove', vm.streaming_active.close = function() {
				    //Your code here
				    vm.streaming_active.deviceId = "";
				    vm.$refs[ref_temp][0].mapObject.getPopup().off('remove', vm.streaming_active.close);				    
				});
			}, // render popup
			actions(act, item, opt){
				if (act == "refresh_cluster"){
					if (this.$refs && this.$refs['clusterRef' + this.layout_id].mapObject) {
						this.$refs['clusterRef' + this.layout_id].mapObject.refreshClusters();
					}
				}
			}, // actions
			doSomethingOnReady() {    			
    			this.$nextTick(() => {
	        		this.map = this.$refs.myMap.mapObject;	        		
	        		this.is_map_ready = true;
	        		this.renderLocations();	        		 
	        		this.onResize();
	        	}); // nextTick
	    	}, // doSomethingOnReady
	    	onResize() {
				const resize_time = setTimeout(function() { 
					window.dispatchEvent(new Event('resize'));
					clearTimeout(resize_time);
      		 	}, 250);
			}, // on resize
			clear_map(){
		    	if (this.marker_static && this.marker_static.length > 0) {
		    		let vm 				= this;
		    		vm.marker_static 	= [];		    		
		    	}
		    }, // clear map

		}, // methods

		mounted(){
			this.onResize();
			if (this.info_to_component) {
				this.renderLocations(this.info_to_component);
			}

		}, // mounted
		beforeDestroy(){    		
    		this.clear_map();    		
  		}, // beforeDestroy
	}
</script>
<style 
	type = "text/css"
	scoped
>
	@import "~leaflet.markercluster/dist/MarkerCluster.css";
	@import "~leaflet.markercluster/dist/MarkerCluster.Default.css";
</style>